import { useState } from 'react';

import { IconX } from '@tabler/icons-react';
import { atom, useAtom } from 'jotai';

import useReportDownload from 'components/ReportsGenerationModal/useReportDownload/useReportDownload';
import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Modal from '@lotlinx-aws/sparky-component-library/Sparky/Modal';
import SelectInput from '@lotlinx-aws/sparky-component-library/Sparky/SelectInput';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import { useToast } from '@lotlinx-aws/sparky-component-library/Sparky/Toast';

import styles from './ReportsGenerationModal.module.scss';

export interface ReportsGenerationModalProps {
  prop?: any;
}

export const showReportGenerationAtom = atom(false);

/**
 * ReportsGenerationModal
 */
export default function ReportsGenerationModal({ prop }: ReportsGenerationModalProps) {
  const [showReportGeneration, setShowReportGeneration] = useAtom(showReportGenerationAtom);
  const [reportType, setReportType] = useState<
    'coreai' | 'vms' | 'vmp' | 'sentinel' | 'qbr' | undefined
  >();

  const { addToast } = useToast();
  const mutation = useReportDownload();
  const handleClick = () => {
    if (reportType !== undefined) {
      mutation.mutate(
        {
          type: reportType,
        },
        {
          onSuccess: () => {
            setReportType(undefined);
            addToast({
              status: 'success',
              duration: 5000,
              description:
                "Your report is being generated - you'll receive an email once it's complete",
            });
          },
        },
      );
    }
  };

  return showReportGeneration ? (
    <Modal
      isOpen={showReportGeneration}
      onDismiss={() => setShowReportGeneration(false)}
      aria-label='Report Generation'
      contentClassName={styles.modalContainer}
    >
      <Flex width='100%' justifyContent='space-between'>
        <Flex margin='16px 0 0'>
          <Text type='heading-03'>Select a report and generate it</Text>
        </Flex>
        <IconButton
          size='sm'
          aria-label='close-button'
          onClick={() => setShowReportGeneration(false)}
        >
          <IconX />
        </IconButton>
      </Flex>
      <SelectInput
        id='report types'
        options={[
          { label: 'Core AI report', value: 'coreai' },
          { label: 'VMS report', value: 'vms' },
          { label: 'Current Sentinel report', value: 'vmp' },
          { label: 'New Sentinel report', value: 'sentinel' },
          { label: 'QBR report', value: 'qbr' },
        ]}
        placeholder='Select a report'
        className={styles.dropdown}
        value={reportType}
        onValueChange={(value: 'coreai' | 'vms' | 'vmp' | 'sentinel' | 'qbr') =>
          setReportType(value)
        }
      />
      <Flex justifyContent='flex-end' gap='8px'>
        <Button
          variant='outline'
          onClick={() => {
            setReportType(undefined);
            setShowReportGeneration(false);
          }}
        >
          Cancel
        </Button>
        <Button disabled={!reportType} variant='solid' onClick={() => handleClick()}>
          Generate
        </Button>
      </Flex>
    </Modal>
  ) : (
    <></>
  );
}
